import { ClientFileType } from "../../../types/clientFileType";
import { Text, Heading } from "../../Type";
import HistoryRow from "./HistoryRow";
import styles from "./index.module.scss";
import EmptyCard from "../../EmptyCard";

const History = ({ client_files }: { client_files: ClientFileType[] }) => {
  return (
    <div className={styles.container}>
      <EmptyCard>
        <div className={styles.title}>
          <Heading size="h5">ACTION</Heading>
          <Heading size="h5">DATE AND TIME</Heading>
        </div>
        {client_files && client_files.length > 0 ? (
          client_files
            .sort((a, b) => parseInt(a.id, 10) - parseInt(b.id, 10))
            .map((c) => {
              return (
                <div key={`${c.id}`} className={styles.section}>
                  {c.file_events && c.file_events.length > 0 ? (
                    [...c.file_events]
                      .sort((a, b) => parseInt(b.id, 10) - parseInt(a.id, 10))
                      .map((f) => (
                        <HistoryRow key={`${c.id}-${f.id}`} event={f} />
                      ))
                  ) : (
                    <Text>No history available</Text>
                  )}
                </div>
              );
            })
        ) : (
          <Text>No File</Text>
        )}
      </EmptyCard>
    </div>
  );
};

export default History;
